import { GAEvent, GAEventNames } from './analytics/events';
import { EventName } from './events/eventsName';
import { GameEvent } from './events/gameEvent';
import { KingPopup } from './KingPopup';
import { showPopup } from './showPopup';
import { Store } from './store/gameStore';
let place = 'win' as 'win' | 'button';

GameEvent.add(EventName.CLOSE_MODAL, onCloseModal);

addEventListener('feedbackError', () => {
    new KingPopup('feedbackError');
    GAEvent(GAEventNames.FEEDBACK_ERROR, {
        number: Store.feedbackCounterShown,
        type: Store.getGameTypeText(),
        difficulty: Store.getDifficultyText(),
        trigger: place,
    });
});
addEventListener('feedbackSuccess', () => {
    new KingPopup('feedbackThankYou');
    Store.blockFeedbackOnWin();
    GAEvent(GAEventNames.FEEDBACK_SEND, {
        number: Store.feedbackCounterShown,
        type: Store.getGameTypeText(),
        difficulty: Store.getDifficultyText(),
        trigger: place,
    });
});
export function openFeedbackPopup(newPlace: 'win' | 'button') {
    place = newPlace;
    showPopup('feedback');
    GAEvent(GAEventNames.FEEDBACK_SHOW, {
        number: Store.feedbackCounterShown,
        type: Store.getGameTypeText(),
        difficulty: Store.getDifficultyText(),
        trigger: newPlace,
    });
}
function onCloseModal({ id, confirm }: { id: string; confirm: boolean }) {
    window.scrollTo(0, 0);
    switch (id) {
        case 'feedback':
            if (!confirm) {
                GAEvent(GAEventNames.FEEDBACK_NOT_NOW, {
                    number: Store.feedbackCounterShown,
                    type: Store.getGameTypeText(),
                    difficulty: Store.getDifficultyText(),
                    trigger: place,
                });
            }
            if (place === 'win') {
                GameEvent.emit(EventName.SHOW_WIN_AFTER_FEEDBACK);
            }
            break;
    }
}
